import AccessDenied from "@assets/SVG/access-denied.svg";
import ThanksCardSvg from "@assets/SVG/thanking-vector.svg";
import { OnBoarding } from "@components/index";
import { Button, Col, Image, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "~/Hooks/useQuery";
import { orgName, supportEmail } from "~/Utils";
import styles from "../Auth.module.scss";

const { Title, Text } = Typography;

export const UserConsentSuccess = () => {
  const [showDenied, setShowDenied] = useState(false);
  const query = useQuery();

  useEffect(() => {
    const errorParam = query.get("error");

    if (errorParam === "access_denied") {
      setShowDenied(true);
    }
  }, []);

  return (
    <OnBoarding>
      <Row>
        <Col
          span={18}
          offset={3}
        >
          <Title
            level={2}
            style={{ textAlign: "center" }}
          >
            {showDenied ? "Access Denied" : "Consent Success!"}
          </Title>
          <Col
            className={styles.textCenter}
            span={24}
          >
            {showDenied && (
              <Image
                className="access-denied"
                src={AccessDenied}
                preview={false}
              />
            )}
            {!showDenied && (
              <Image
                src={ThanksCardSvg}
                preview={false}
              />
            )}
          </Col>
          {showDenied && (
            <Col
              className="consent-access-denied"
              style={{ padding: `${styles.whitespace2} 0px` }}
            >
              <div>
                <Typography.Text>User consent is a mandatory requirement for using {orgName} CLM.</Typography.Text>
              </div>
              <div>
                <Typography.Text>We kindly request you to log in again and submit your consent.</Typography.Text>
              </div>
              <div>
                <Typography.Text>
                  If you have any questions about submitting consent, feel free to contact our support team
                  <a
                    style={{ marginLeft: styles.whitespace1 }}
                    href={`mailto:${supportEmail}`}
                  >
                    {supportEmail}.
                  </a>
                </Typography.Text>
              </div>
            </Col>
          )}
          {!showDenied && (
            <Col className={styles.textCenter}>
              <Typography.Text style={{ padding: `${styles.whitespace2} 0px`, color: styles.gray }}>
                Great news! The DocuSign user consent has been successfully accepted. To access the {orgName} CLM,
                kindly proceed by logging in using the link provided below.
              </Typography.Text>
            </Col>
          )}
          <Col
            className={styles.textCenter}
            span={24}
            style={{ marginTop: styles.whitespace1 }}
          >
            <Typography.Text className={styles.loginDontText}>
              <Link to="/auth/login">
                <Button type={"primary"}>Go back to Login</Button>
              </Link>
            </Typography.Text>
          </Col>
        </Col>
      </Row>
    </OnBoarding>
  );
};
